// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Bezárás',
  error: () => 'Hiba',
  warn: () => 'Figyelmeztetés',
  info: () => 'Információ',
  confirmation: () => 'Megerősítés',
  progressIndeterminate: () => 'Folyamatban',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    p['FROM_SECTION'] + ' és ' + p['TO_SECTION'] + ' között.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nem található egyező szakasz.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Az érték kiválasztásához nyomja meg az Enter billentyűt.',
  indexer_touchInstructionText: () =>
    'A gesztus módba belépéshez dupla koppintás és megtartás, majd lefelé vagy felfelé húzás az érték beállításához.',
  inputPassword_show: () => 'Jelszó megjelenítése',
  inputPassword_hide: () => 'Jelszó elrejtése',
  inputPassword_hidden: () => 'Jelszó elrejtve',
  formControl_clear: () => 'Törlés',
  formControl_loading: () => 'Betöltés',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Túllépte a maximális hosszt: ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' karakter maradt.',
  formControl_requiredMessageDetail: () => 'Adjon meg egy értéket.',
  select_requiredMessageDetail: () => 'Jelöljön ki egy értéket.',
  select_noMatchesFound: () => 'Nincs találat.',
  select_oneMatchFound: () => 'Egy egyezés található',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' egyezés található',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' vagy több egyezés található',
  selectMultiple_selectedValues: () => 'Kiválasztott értékek',
  selectMultiple_showSelectedValues: () => 'Csak a kijelölt értékek megjelenítése.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' kiválasztott érték.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'A kijelölt érték eltávolításához nyomja meg a Backspace vagy a Delete billentyűt.',
  selectMultiple_apply: () => 'Alkalmaz',
  selectMultiple_back: () => 'Vissza',
  selector_selected: () => 'Jelölőnégyzet bejelölve',
  selector_unselected: () => 'Jelölőnégyzet nincs bejelölve',
  userAssistance_learnMore: () => 'További tudnivalók',
  userAssistance_required: () => 'Kötelező',
  filePicker_singleFileUploadError: () => 'Egyszerre csak egy fájlt töltsön fel',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nem tölthet fel ' + p['fileType'] + ' típusú fájlt',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nem tölthet fel ' + p['fileTypes'] + ' típusú fájlt',
  filePicker_unknownFileTypeUploadError: () => 'ismeretlen',
  filePicker_dropzonePrimaryText: () => 'Áthelyezés húzással',
  filePicker_dropzoneSecondaryText: () => 'Válassza ki a fájlt, vagy húzza át ide',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Válassza ki a fájlokat, vagy húzza át ide',
  filePicker_addFiles: () => 'Fájlok hozzáadása',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Növelés',
  inputNumber_decrease: () => 'Csökkentés',
  inputNumber_converterParseError: () => 'Adjon meg egy számot.',
  noData_message: () => 'Nincs megjeleníthető elem',
  message_navigationFromMessagesRegion: () =>
    'Belépés az üzenetek régióba. Az F6 billentyűvel léphet a korábban kijelölt elemhez.',
  message_navigationToMessagesRegion: () =>
    'Az üzenetek régióban új üzenetek találhatók. Az F6 billentyűvel léphet a legutóbbi üzenetrégióhoz.',
  messageToast_allMessagesClosed: () => 'Az összes információs üzenet bezárva.',
  expandableList_groupCollapse: () => 'Összecsukott',
  expandableList_groupExpand: () => 'Kibontott',
  expandableList_expandCollapseInstructionText: () =>
    'A kibontáshoz és összecsukáshoz használja a nyílbillentyűket',
  list_suggestion: () => 'Javaslat',
  train_status: (p: { numberOfSteps: string; currentStep: string }) =>
    p['numberOfSteps'] + '/' + p['currentStep'] + '. lépés',
  train_current: () => 'Aktuális',
  train_visited: () => 'Látogatott',
  train_not_visited: () => 'Nem látogatott',
  train_message_type: () => 'Üzenet típusa',
  viz_drillable: () => 'Részletezhető',
  dataVisualization_stateSelected: () => 'Kijelölt',
  dataVisualization_stateUnselected: () => 'Nem kijelölt',
  dataVisualization_noData: () => 'Nincs megjeleníthető adat'
};
export default bundle;
